import { type FC } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import i18n from '@shared/config/i18n';
import type { Props } from './types';

export const ConfirmDialog: FC<Props> = ({
  title,
  isOpen,
  content,
  confirmButtonText = i18n.t('Confirm'),
  onClose,
  onConfirm,
}) => (
  <Dialog open={isOpen} onClose={onClose} maxWidth="xs">
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText color="textPrimary">{content}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button variant="contained" color="primary" onClick={onConfirm}>
        {confirmButtonText}
      </Button>
      <Button variant="outlined" color="primary" onClick={onClose}>
        {i18n.t('cancel')}
      </Button>
    </DialogActions>
  </Dialog>
);
